import "./VehicleDeleteModal.scss";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { closeModal } from "../../../slices/modalSlice";
import { setShowAlert } from "../../../slices/alertSlice";

import { fetchDeleteVehicle } from "../../../slices/deleteVehicleClice";

import { Button } from "../../../common-components/Buttons/Buttons";
import { LargeTitle } from "../../../common-components/Titles/Titles";
import { MiddleTitle } from "../../../common-components/Titles/Titles";

const VehicleDeleteModal = ({id}) => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token);
    const error = useSelector((state) => state.deleteVehicle.error);

    const handleClose = () => {
        dispatch(closeModal());
    }

    const handleDelete = () => {
        dispatch(fetchDeleteVehicle({token, id}))
            .unwrap()
            .then(() => {
                window.location.reload();
            })
            .catch(() => {
                setShowAlert({type: 'error', messages: error});
            })
    }

    return (
        <div className={"vehicle-delete-modal"}>
            <div className={"vehicle-delete-modal_container"}>
                <div className={"vehicle-delete-modal_title"}>
                    <LargeTitle property={`Удаление транспорта #${id}`}/>
                </div>
                <div className={"vehicle-delete-modal_descr"}>
                    <MiddleTitle property={"Вы действительно хотите удалить транспорт?"}/>
                </div>
                <div className={"vehicle-delete-modal_buttons"}>
                    <div className={"vehicle-delete-modal_button"}>
                        <Button title={"Нет"} color={"#eeeeee"} textColor={"#212121"} onClick={handleClose}/>
                    </div>
                    <div className={"vehicle-delete-modal_button"}>
                        <Button title={"Да"} onClick={handleDelete}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VehicleDeleteModal;